import React, { type FC, type PropsWithChildren } from "react";

import cn from "classnames";

import type { IslandProps } from "./types";

import classes from "./Island.styl";

const ISLAND_TEST_ID = "island-test-id";
const ISLAND_DISPLAY_NAME = "Island";

/**
 * Компонент, умеющий наделять контейнер такими свойствами, как цвет фона, цвет. Управляет внутренними отступами
 *
 * <a href="https://www.figma.com/design/SZCPsHnuqBIWlYSyfmq0j1/%F0%9F%A7%A9-Sheets-%26-Modules-%26-Wrappers?node-id=825-121607&t=NskrdHQp5fxPneoP-1" target="_blank">Спека</a>
 * @constructor
 */
export const Island: FC<PropsWithChildren<IslandProps>> = (props) => {
    const {
        children,
        roundTopCorners = true,
        roundBottomCorners = true,
        customVarsStyles,
        "data-tsid": tsid,
    } = props;

    const islandClasses = cn(classes["island"], customVarsStyles, {
        [classes["__disable-top-corners"]]: !roundTopCorners,
        [classes["__disable-bottom-corners"]]: !roundBottomCorners,
    });

    return (
        <div
            className={islandClasses}
            data-tsid={tsid || ISLAND_TEST_ID}
            data-uikit={ISLAND_DISPLAY_NAME}
        >
            {children}
        </div>
    );
};

Island.displayName = ISLAND_DISPLAY_NAME;

export default Island;
